<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>

    <!--  Banner Starts Here   -->
    <section class="home_banner">
      <div class="container_large">
        <div class="home_banner_content">
          <h2>Don't be a Superhero...</h2>
          <h1>Let <span>Dirty Drawz</span> Handle</h1>
          <p>Your Laundry & Dry-Cleaning Needs!</p>
          <div class="services_area">
            <h4>See if we service your area</h4>
            <!-- <form method="" action=""> -->
            <div class="area_input">
              <!-- <input
                  type="text"
                  name=""
                  placeholder="Street address, city, state"
                /> -->
              <!-- <vue-google-autocomplete
                  ref="address"
                  id="map"
                  classname="form-control"
                  placeholder="Street address, city, state"
                  v-on:placechanged="getAddressData"
                  country="us"
                >
                </vue-google-autocomplete>
                <button type="button">Search</button> -->
              <input
                type="text"
                name=""
                placeholder="Zip Code"
                v-model="postal"
              />
              <button type="submit" @click.prevent="checkPostal()">
                Search
              </button>
            </div>

            <!-- <transition name="fade" v-if="is_show_postal">
                <div class="mt-8">
                  <div class="error_message">
                    We haven't find your postal code from google map please enter
                  your postal code
                  </div>
                  <div class="area_input">
                    <input
                      type="text"
                      name=""
                      placeholder="Postal Code"
                      v-model="postal"
                    />
                    <button type="submit" @click.prevent="checkPostal()">
                      Submit
                    </button>
                  </div>
                </div>
              </transition> -->

            <transition name="fade" v-if="is_postal_found">
              <div class="sucess_message">
                <strong>Congrats!</strong> we serve in your area.
              </div>
            </transition>
            <transition name="fade" v-if="is_postal_found == false">
              <div class="error_message">
                <strong>Sorry!</strong> we do not currently service this area!
              </div>
            </transition>
            <!-- </form> -->
          </div>
        </div>
      </div>
      <div class="banner_img">
        <img
          src="/src/assets/images/masketo-men.png"
          class="img-fluid"
          alt=""
        />
      </div>
    </section>
    <!--  Banner Ends Here   -->

    <!--   Main Content Start Here   -->
    <main>
      <section class="get_reviews">
        <div class="container">
          <!-- <div class="reviews_title">Get a review on</div> -->
          <div class="reviews_logo">
            <ul>
              <li>
                <a href="#"
                  ><img src="/src/assets/images/google-review.png" alt=""
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="/src/assets/images/fb-reviews.png" alt=""
                /></a>
              </li>
              <li>
                <a href="#"><img src="/src/assets/images/yelp.png" alt="" /></a>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="how_we_work" id="how-we-works">
        <div class="container_large">
          <div class="section_heading">
            <h2>How We Work</h2>
            <h4>It's as easy as 1-2-3</h4>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="how_we_work_col">
                <div class="how_we_work_col_icon">
                  <img src="/src/assets/images/incoming-call.svg" alt="" />
                </div>
                <h2>Sign Up Or Call</h2>
                <p>
                  Use our simple online system to schedule your pickup and
                  deliveries or<br />
                  call
                  <a href="tel:877-973-7299" style="color: #fc6d4c">
                    877-973-7299
                  </a>
                  / email
                  <a href="mailto:info@dirtydrawz.com" style="color: #fc6d4c">
                    info@dirtydrawz.com</a
                  >
                </p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="how_we_work_col">
                <div class="how_we_work_col_icon">
                  <img src="/src/assets/images/schedule.svg" alt="" />
                </div>
                <h2>Schedule a Pickup</h2>
                <p>We’ll service your home, business, or school</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="how_we_work_col">
                <div class="how_we_work_col_icon">
                  <img src="/src/assets/images/clean-cloths.svg" alt="" />
                </div>
                <h2>Clean Clothes</h2>
                <p>Clothes are retured looking and feeling brand-new!</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="pricing_services" id="pricing">
        <div class="container_large">
          <div class="section_heading">
            <!-- <h4>What We Offer</h4> -->
            <h2>Pricing & Services</h2>
            <h3>
              <span><u>Free</u></span> Delivery with
              <strong>every</strong> order
            </h3>
          </div>
          <div class="row justify-content-center">
            <div class="col-12 col-md-6 col-lg-4">
              <div class="pricing_column">
                <div class="pricing_column_icon">
                  <img src="/src/assets/images/white-washer.svg" alt="" />
                </div>
                <h2>Wash and Fold</h2>
                <ul>
                  <li>Next Day Delivery</li>
                  <li>$ 2.25 per round (15 lbs Min)</li>
                  <li>Clothes Looking, Smelling & Feeling Fresh</li>
                </ul>
                <div class="order_now" v-if="current_user && current_user.id">
                  <router-link 
                    :to="{ name: 'order' }"
                    class="button primary_button"
                    >Order Now</router-link
                  >
                  </div>
                <div class="order_now" v-if="current_user == null">

                  <router-link 
                    :to="{ name: 'signup' }"
                    class="button primary_button"
                    >Order Now</router-link
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="pricing_column">
                <div class="pricing_column_icon">
                  <img src="/src/assets/images/shirt.svg" alt="" />
                </div>
                <h2>Dry Cleaning</h2>
                <ul>
                  <li>Eco - Friendly</li>
                  <li>Quick Turn Around</li>
                  <li>Pressed to Prefection</li>
                </ul>
                <div class="order_now" v-if="current_user && current_user.id">
                  <router-link 
                    :to="{ name: 'order' }"
                    class="button primary_button"
                    >Order Now</router-link
                  >
                  </div>
                <div class="order_now" v-if="current_user == null">

                  <router-link 
                    :to="{ name: 'signup' }"
                    class="button primary_button"
                    >Order Now</router-link
                  >
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <div class="pricing_column">
                <div class="pricing_column_icon">
                  <img src="/src/assets/images/sewing-machine.svg" alt="" />
                </div>
                <h2>Tailoring</h2>
                <ul>
                  <li>Buttons, zippers, hemming- you name it, we do it!</li>
                  <li>Precise Alterations</li>
                  <li>Quality Material!</li>
                </ul>
                 <div class="order_now" v-if="current_user && current_user.id">
                  <router-link 
                    :to="{ name: 'order' }"
                    class="button primary_button"
                    >Order Now</router-link
                  >
                  </div>
                <div class="order_now" v-if="current_user == null">

                  <router-link 
                    :to="{ name: 'signup' }"
                    class="button primary_button"
                    >Order Now</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="faqs">
        <div class="container_large">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="faq_img">
                <img
                  src="/src/assets/images/faq-img.png"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="faqs_holder">
                <div class="section_heading">
                  <h2>Frequently Asked Questions</h2>
                </div>
                <div class="faq_content">
                  <div
                    class="accordion"
                    id="accordionExample"
                    v-if="faqs && faqs.data && faqs.data.length"
                  >
                    <div
                      class="accordion-item"
                      v-for="(data, index) in faqs.data"
                      :key="data.id"
                    >
                      <h2 class="accordion-header" :id="'heading' + index">
                        <button
                          class="accordion-button"
                          :class="{ collapsed: index != 0 }"
                          type="button"
                          data-bs-toggle="collapse"
                          :data-bs-target="'#collapse' + index"
                          :aria-expanded="index == 0 ? true : false"
                          :aria-controls="'collapse' + index"
                        >
                          {{ data.question ? data.question : "" }}
                        </button>
                      </h2>
                      <div
                        :id="'collapse' + index"
                        class="accordion-collapse collapse"
                        :class="{ show: index == 0 }"
                        :aria-labelledby="'heading' + index"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          {{ data.answer ? data.answer : "" }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="view_all">
                    <router-link :to="{ name: 'faqs' }"
                      >View All
                      <img src="/src/assets/images/forward-arrow.svg" alt=""
                    /></router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="mailing_list">
        <div class="container_large">
          <div class="mailing_list_content">
            <h2>Join Our Mailing List</h2>
            <p>
              Subscribe to our newsletter to receive special offers and company
              updates.
            </p>
            <form method="" action="" @submit.prevent="subscribed()">
              <div
                class="alert alert-success alert-dismissible"
                v-if="status && status == 200"
              >
                <strong>Success!</strong> You have successfully subscribed.
              </div>
              <div class="area_input">
                <input
                  type="email"
                  name=""
                  placeholder="Enter your email"
                  v-model="subscribe.email"
                  required
                />
                <button type="submit">Subscribe</button>
              </div>
            </form>
          </div>
          <div class="delivery_van">
            <img
              src="/src/assets/images/delivery-van.png"
              class="img-fluid"
              alt=""
            />
          </div>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->
  </div>
</template>
<script>
import faqsApis from "../Apis/faqs";
import emailSubscribersApis from "../Apis/emailSubscribers";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import usersApis from "../Apis/users";

export default {
  components: { VueGoogleAutocomplete },
  data() {
    return {
       current_user: !!localStorage.getItem("current_user")
          ? JSON.parse(localStorage.getItem("current_user"))
          : null, 
      loader: true,
      faqs: null,
      address: null,
      postal: null,
      is_show_postal: false,

      is_postal_found: null,

      given_areas: [],

      subscribe: {
        email: null,
      },
      status: null,
    };
  },
  methods: {
    checkPostal() {
      const index = this.given_areas.findIndex((it) => it == this.postal);
      if (index === -1) {
        this.is_postal_found = false;
      } else {
        this.is_postal_found = true;

        // setTimeout(() => {
        this.$router.push({
          name: "signup",
          params: { zip_code: this.postal },
        });
        // }, 2000);
      }
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address =
        placeResultData && placeResultData.formatted_address
          ? placeResultData.formatted_address
          : "";

      if (addressData && addressData.postal_code) {
        this.is_show_postal = false;
        const index = this.given_areas.findIndex(
          (it) => it == addressData.postal_code
        );
        if (index === -1) {
          /**postal code not exist in array */
          this.is_postal_found = false;
        } else {
          /**postal code exist in array */
          this.is_postal_found = true;

          setTimeout(() => {
            this.$router.push({
              name: "signup",
              params: { address: this.address },
            });
          }, 2000);
        }
      } else {
        this.is_show_postal = true;
      }
      // console.log(id);
    },

    async subscribed() {
      this.status = (
        await emailSubscribersApis.requestSubscribers("post", this.subscribe)
      ).status;
    },
  },
  async created() {
    await usersApis.getCSRF();

    this.faqs = (await faqsApis.requestPaginatedFaqs(4)).data;

    this.given_areas.push("02127");
    this.given_areas.push("02118");
    this.given_areas.push("02123");
    this.given_areas.push("02116");
    this.given_areas.push("02108");
    this.given_areas.push("02215");
    this.given_areas.push("02120");
    this.given_areas.push("02474");
    this.given_areas.push("02476");
    this.given_areas.push("02134");
    this.given_areas.push("02478");
    this.given_areas.push("02135");
    this.given_areas.push("02445");
    this.given_areas.push("02446");
    this.given_areas.push("02138");
    this.given_areas.push("02138");
    this.given_areas.push("02139");
    this.given_areas.push("02140");
    this.given_areas.push("02141");
    this.given_areas.push("02142");
    this.given_areas.push("02163");
    this.given_areas.push("02238");
    this.given_areas.push("02150");
    this.given_areas.push("02108");
    this.given_areas.push("02109");
    this.given_areas.push("02110");
    this.given_areas.push("02111");
    this.given_areas.push("02112");
    this.given_areas.push("02117");
    this.given_areas.push("02118");
    this.given_areas.push("02127");
    this.given_areas.push("02113");
    this.given_areas.push("02114");
    this.given_areas.push("02115");
    this.given_areas.push("02116");
    this.given_areas.push("02123");
    this.given_areas.push("02128");
    this.given_areas.push("02133");
    this.given_areas.push("02163");
    this.given_areas.push("02196");
    this.given_areas.push("02199");
    this.given_areas.push("02205");
    this.given_areas.push("02206");
    this.given_areas.push("02212");
    this.given_areas.push("02215");
    this.given_areas.push("02266");
    this.given_areas.push("02283");
    this.given_areas.push("02201");
    this.given_areas.push("02203");
    this.given_areas.push("02204");
    this.given_areas.push("02210");
    this.given_areas.push("02211");
    this.given_areas.push("02217");
    this.given_areas.push("02222");
    this.given_areas.push("02241");
    this.given_areas.push("02284");
    this.given_areas.push("02293");
    this.given_areas.push("02295");
    this.given_areas.push("02297");
    this.given_areas.push("02298");
    this.given_areas.push("02129");
    this.given_areas.push("02467");
    this.given_areas.push("02121");
    this.given_areas.push("02122");
    this.given_areas.push("02124");
    this.given_areas.push("02125");
    this.given_areas.push("02149");
    this.given_areas.push("02130");
    this.given_areas.push("02148");
    this.given_areas.push("02153");
    this.given_areas.push("02155");
    this.given_areas.push("02176");
    this.given_areas.push("02492");
    this.given_areas.push("02461");
    this.given_areas.push("02464");
    this.given_areas.push("02459");
    this.given_areas.push("02465");
    this.given_areas.push("02458");
    this.given_areas.push("02462");
    this.given_areas.push("02151");
    this.given_areas.push("02118");
    this.given_areas.push("02119");
    this.given_areas.push("02120");
    this.given_areas.push("02170");
    this.given_areas.push("02169");
    this.given_areas.push("02171");
    this.given_areas.push("02269");
    this.given_areas.push("02144");
    this.given_areas.push("02145");
    this.given_areas.push("02451");
    this.given_areas.push("02452");
    this.given_areas.push("02453");
    this.given_areas.push("02454");
    this.given_areas.push("02472");
    this.given_areas.push("02471");
    this.given_areas.push("02477");
    this.given_areas.push("02482");
    this.given_areas.push("02132");
    this.given_areas.push("01890");
    this.loader = false;
  },
};
</script>
<style scoped>
html {
  scroll-behavior: smooth;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue